import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { useSelector } from 'hooks/useSelector';
import React from 'react';
import { LightRepeatableListItem } from 'screens/AssetScreen/Field/LightRepeatableListItem';
import {
  selectAssetFieldInstanceResultValue,
  selectAssetFieldResultValue,
  selectAssetOrganisationId,
} from 'store/assets/selectors';
import { selectOrganisationFieldGroup } from 'store/organisations/selectors';

type Props = {
  assetId: string;
  // The instance ID that holds the instances (e.g. Flat)
  parentInstanceId: string | null;
  // The field ID of the parent instance that holds the results
  parentFieldId: string;
  // The group that is added to the parent (e.g. Flat Door)
  childGroupId: string;
};

export const ChildGroupLightAsset: React.FC<Props> = ({
  assetId,
  parentFieldId,
  parentInstanceId,
  childGroupId,
}) => {
  const organisationId = useSelector((state) =>
    selectAssetOrganisationId(state, assetId, childGroupId),
  );

  const childGroup = useSelector((state) =>
    selectOrganisationFieldGroup(state, organisationId, childGroupId),
  );

  const rawChildInstanceIds = useSelector((state) =>
    parentInstanceId
      ? selectAssetFieldInstanceResultValue(
          state,
          assetId,
          parentInstanceId,
          parentFieldId,
        )
      : selectAssetFieldResultValue(state, assetId, parentFieldId),
  );

  if (!childGroup) {
    return null;
  }

  const childInstanceIds = Array.isArray(rawChildInstanceIds)
    ? rawChildInstanceIds
    : [];

  return childInstanceIds.length ? (
    <Card label={childGroup.name}>
      {childInstanceIds.map((childInstanceId) => (
        <LightRepeatableListItem
          key={childInstanceId}
          instanceId={childInstanceId}
          assetId={assetId}
          group={childGroup}
          parent={{
            fieldId: parentFieldId,
            instanceId: parentInstanceId,
          }}
        />
      ))}
    </Card>
  ) : (
    <Card label={childGroup.name}>
      <CardRow value={`No ${childGroup.name}`} />
    </Card>
  );
};
